import { Component, Input, OnInit } from '@angular/core';
import { ILoading } from './i-loading';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent implements OnInit {
  @Input() isSpinning: ILoading;
  @Input() message = 'Loading...';
  @Input() hasCardSectionMargins = false;

  get spinnerCssClass(): string {
    if (this.hasCardSectionMargins) {
      return 'cardSectionMarginsForSpinner';
    }
    return '';
  }

  constructor() {}

  ngOnInit() {}
}